import { render } from "./ic-times.vue?vue&type=template&id=e99b2402"
import script from "./ic-times.vue?vue&type=script&lang=js"
export * from "./ic-times.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__